import './MobileMenuToggle.scss';
import React from 'react';
import PropTypes from 'prop-types';

import CrossIcon from 'components/shared/icons/CrossIcon';

class MobileMenuToggle extends React.Component {
  static propTypes = {
    isNavMenuOpen: PropTypes.bool.isRequired,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static Constants = {
    dataToggle: 'collapse',
    dataTarget: '.navbar-collapse',
  };

  renderShortstack() {
    const { getString } = this.context;
    return (
      <span className="navbar-shortstack">
        <span className="sr-only">{getString('AA_Menu')}</span>
        <span className="icon-bar" />
        <span className="icon-bar" />
        <span className="icon-bar" />
      </span>
    );
  }

  render() {
    return (
      <div className="navbar-header pull-left">
        <button
          type="button"
          className="navbar-toggle collapsed pull-left"
          data-toggle={MobileMenuToggle.Constants.dataToggle}
          data-target={MobileMenuToggle.Constants.dataTarget}
          aria-expanded={this.props.isNavMenuOpen}
        >
          <span className="pull-left aa-nav-icon">
            {this.props.isNavMenuOpen ? <CrossIcon /> : this.renderShortstack()}
          </span>
        </button>
      </div>
    );
  }
}

export default MobileMenuToggle;
